export { default } from './src/insert-link-to-anchor';
